import React, { FC } from 'react'

import { Redirect, Route, Switch } from 'react-router-dom'

import Task from 'components_new/pages/Task'
import Tasks from 'components_new/pages/Tasks'

import { useAllowAccessAnalyses } from 'redux/hooks/Permissions'

import AuthRoute from './AuthRoute'

const Routes: FC = () => {
  const isAuthenticated = useAllowAccessAnalyses()

  return (
    <Switch>
      <AuthRoute
        Component={() => <Task />}
        isAuthenticated={isAuthenticated}
        path={'/tasks/:id'}
      />
      <AuthRoute
        Component={() => <Tasks />}
        isAuthenticated={isAuthenticated}
        path={'/tasks'}
      />
      <Route path={'/tasks/*'}>
        <Redirect to="/tasks" />
      </Route>
    </Switch>
  )
}

export default Routes
